module.exports = __webpack_public_path__ + "static/site-problem-6879d7308649165e316323df5bb0ebb9.jpg";